export default __webpack_public_path__ + "static/media/loop_res.6812d184.PNG";